import React from 'react';
import PropTypes from 'prop-types';
import { renderStars, renderPerfectFor } from './../helpers';
import Rooms from './Rooms';
import { hotelAmenities } from './../constants';
import { Hotel as S } from './../styles';

class PopOver extends React.Component {
  handleClick = () => {
    this.props.onCancel(false);
  }
  render() {
    const {
      hotel: {
        name,
        desc,
        amenities,
        stars,
        perfectFor,
        roomImages,
        distance,
        deeplink,
      },
    } = this.props;
    const rooms = this.props.hotel.room_set;
    return (
      <S.PopOver
        visible={this.props.visible}
        onCancel={() => this.handleClick()}
        width="700px"
        footer={null}
        closable={false}
        centered={true}
        maskStyle={{ backgroundColor: 'rgba(255,255,255,.9)' }}
      >
        <button className="close" onClick={() => this.handleClick()}>&times;</button>
        <h3><span>{name}</span> { renderStars(stars)}</h3>
        {renderPerfectFor(perfectFor)}
        <p>Distance to venue: {distance < 100 ? (`${distance}-min walk`) : 'varies'}</p>
        <h6>ABOUT THE HOTEL:</h6>
        <p style={{ marginBottom: '15px' }}>{desc}</p>
        <S.AmenitiesWrapper>
          <p>Amenities:</p>
          <S.Amenities>
            { amenities.map((item) => (
              <S.Amenity key={item.toString()}>
                <img src={hotelAmenities[item].icon} alt={hotelAmenities[item].name} />
                <span>{hotelAmenities[item].name}</span>
              </S.Amenity>
            )) }
          </S.Amenities>
        </S.AmenitiesWrapper>
        {rooms.length > 0 ? <Rooms rooms={rooms} roomImages={roomImages} hotelName={name} deeplink={deeplink} /> : null}
        <div style={{ maxWidth: '350px', margin: '0 auto' }}>
          <a href={deeplink} target="blank">
            <S.ButtonLink size="1.6em" data-hotel-name={name}>Book your room now</S.ButtonLink>
          </a>
          <p style={{ fontSize: '1.4em', textAlign: 'center' }}><span className="asterisk">*</span> Pricing approximate in subject to exchange rates. You will pay in the hotel&apos;s local currency (THB).</p>
        </div>
      </S.PopOver>
    );
  }
}

PopOver.propTypes = {
  hotel: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default PopOver;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/PopOver.js